import React, {useEffect} from 'react'
import PSIResourcesModule from '../../components/Measures/PSIResources';

const PSIResources = () => {
    return (<>
    <PSIResourcesModule />
    </>)
}

export default PSIResources;